export const getFilenameFromUrl = {
  methods: {
    getFilenameFromUrl (url, noThumb) {
      noThumb = noThumb || false
      var result = {}
      if (url) {
        var filename = url.match(/[^/\\&?]+\.\w{3,4}(?=([?&].*$|$))/)
        if (!filename || filename === null) {
          return false
        } else {
          filename = filename[0]
        }
        var parts = filename.split('.')
        var extension = parts.pop()
        var file = parts.join('.')
        var base = url.split(file)[0]

        if (noThumb) {
          result = {
            file: file,
            ext: extension,
            name: file,
            full: file + '.' + extension,
            fullUrl: url
          }
        } else {
          result = {
            file: file,
            ext: extension,
            name: file.split('_')[0],
            full: file.split('_')[0] + '.' + extension,
            fullUrl: base + file.split('_')[0] + '.' + extension,
            thumb: file + '.' + extension,
            thumbUrl: base + file + '.' + extension
          }
        }
      }
      return result
    }
  }
}
